export default __webpack_public_path__ + "static/media/double-check.045b3614.svg";